import { render, staticRenderFns } from "./DocumentEncryptionConfiguration.vue?vue&type=template&id=09644aa7&scoped=true&"
import script from "./DocumentEncryptionConfiguration.vue?vue&type=script&lang=ts&"
export * from "./DocumentEncryptionConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEncryptionConfiguration.vue?vue&type=style&index=0&id=09644aa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09644aa7",
  null
  
)

export default component.exports